import { gql } from "lib/apolloClient";

const assessmentFragment = gql`
  fragment assessmentItem on Assessment {
    id
    type
    isImported
    title {
      id
      value
    }
    academicTerm {
      id
      lockingStatus
    }
    assessmentType {
      id
      value
    }
    taskType {
      id
      type
      label
      color
      displaySequence
    }
    image {
      id
      value
    }
    category {
      id
      label
    }
    lockingInfo {
      isLocked
    }

    isSyncedWithAllTeacherCourseV2(filters: { learningCourseId: $parentId }) {
      status
      isConflictExists
      courseSyncStatus {
        course {
          id
          title
        }
        status
      }
    }
    taggedPractices {
      evaluationCycle {
        id
      }
      taggedPractice {
        taggedBy {
          id
        }
        practice {
          id
        }
        evidenceStatus
      }
    }
  }
`;

const attachmentFragment = gql`
  fragment attachmentItem on Attachment {
    id
    attachmentType: type
    attachmentTitle: title
    name
    mimeType
    url
    signedUrl
    thumbUrl
    __typename
  }
`;

export const unitFlowItem = gql`
  fragment unitFlowItem on LearningCourseFlow {
    id
    label
    displaySequence
    resourceType: itemType
    lockingInfo {
      isLocked
    }

    isSyncedWithAllTeacherCourseV2(filters: { learningCourseId: $parentId }) {
      status
      isConflictExists
      courseSyncStatus {
        course {
          id
          title
        }
        status
      }
    }
    item {
      ... on Assessment {
        ...assessmentItem
      }
      ... on Attachment {
        ...attachmentItem
      }
    }
    parent {
      id
    }
  }
  ${assessmentFragment}
  ${attachmentFragment}
`;
